"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAllQuestConfigsForUserResponseAllOfToJSON = exports.GetAllQuestConfigsForUserResponseAllOfFromJSONTyped = exports.GetAllQuestConfigsForUserResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetAllQuestConfigsForUserResponseAllOfFromJSON(json) {
    return GetAllQuestConfigsForUserResponseAllOfFromJSONTyped(json, false);
}
exports.GetAllQuestConfigsForUserResponseAllOfFromJSON = GetAllQuestConfigsForUserResponseAllOfFromJSON;
function GetAllQuestConfigsForUserResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'questConfigs': (json['questConfigs'].map(_1.QuestConfigFromJSON)),
    };
}
exports.GetAllQuestConfigsForUserResponseAllOfFromJSONTyped = GetAllQuestConfigsForUserResponseAllOfFromJSONTyped;
function GetAllQuestConfigsForUserResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'questConfigs': (value.questConfigs.map(_1.QuestConfigToJSON)),
    };
}
exports.GetAllQuestConfigsForUserResponseAllOfToJSON = GetAllQuestConfigsForUserResponseAllOfToJSON;
